import {CoworkHomeContactComponent} from './cowork-home-contact.component'; 
import {CoworkHomeSearchComponent} from './cowork-home-search.component'
import {CoworkHomeDetailComponent} from './cowork-home-detail.component';
import {CoworkFeaturedSpacesComponent} from './cowork-featured-spaces.component';
import {CoworkPopularSpacesComponent} from './cowork-popular-spaces.component';
import {CoworkTopCitiesComponent} from './cowork-top-cities.component';
import {CoworkCategoriesComponent} from './cowork-categories.component';
import {CoworkFeaturedPartnersComponent} from './cowork-featured-partners.component';
import {CoworkPopularPartnersComponent} from './cowork-popular-partners.component';
import {CoworkOffersComponent} from './cowork-offers.component';
import {getLoggedInUser} from '../../loginService'
import {getterSetter} from '../../utils/common';
import {getCookie} from '../../services/cookieService'
import {isSet,isEmpty,isMobile,replaceSpace} from '../../utils/common';
import {addPageView} from './coworkga';

//import {smoothScroll, elmYPosition} from '../../utils/common';
//import '../../services/gaService.js';
import {Component} from '../../core';

/**
 * Cowork component
 */
export class CoworkHomeComponent extends Component {

    constructor(el) {
        super(el);
    }

    onComponentLoaded() {

        getLoggedInUser.then((result) => {
            if(result && result.data && result.data.user){
                getterSetter.set( 'loginData', result);
                getterSetter.set( 'loginstatus', true);
            }else{
                getterSetter.set( 'loginstatus', false);
            }
            return true;
        });

        //Initialize the top cities
        this.initializeTopCities();

        // Initialize the contact form
        this.initializeContactForm();

        // Initialize the search box
        this.initializeSearchBox();

        //Initialize the categories
        this.initializeCategories();

        // Initialize the featured spaces
        this.initializeFeaturedSpaces();

        // Initialize the popular spaces
        this.initializePopularSpaces();

        // Initialize the featured partners
        this.initializeFeaturedPartners();

        // Initialize the popular partners
        this.initializePopularPartners();

        // Initialize the offers
        this.initializeOffers();

        // Initialize service cities
        //this.initializeServiceCities();

        // Initialize page view
        this.initializePageView();

    }

    /**
     * Initializes  page view
     */
    initializePageView() {
        let url = '/hp?catname=QH_CoWork';
        let cityName = globals.cityName;
        if(!isEmpty(cityName)) {
            url += '&City='+replaceSpace(cityName);
        }
        url += ',v72=True';
        addPageView(url);
    }

    /**
     * Initializes  service cities
     */
    initializeServiceCities() {
        if (isSet(getCookie("prefer_city_id"))) {
            let city_id = getCookie("prefer_city_id");
            this.fetchCoworkProperty(city_id).then((result) => {
                if(result && result.total >0) {
                    window.location = window.location.protocol + "//" + window.location.host + '/coworking/coworking-spaces-in-' + city.toLowerCase()+'-cid_' + city_id;
                } else {
                    alert("Currently we are live in the following cities: Bangalore, Chennai, Hyderabad, Mumbai, Pune and Navi Mumbai. We are adding properties in more cities. Meanwhile, please fill up your requirement and we will find the space for you.");
                    var elmnt = document.getElementById("contactUs");
                    elmnt.scrollIntoView();
                }
            });
        }
    }

    fetchCoworkProperty(cityId) {
        return fetch(`/homes/re2/checkCoworkProeprty?aj=1&cityId=${cityId}`).then((res) => res.json())
    }

    /**
     * Initializes the contact form
     */
    initializeContactForm() {
        const contactComponent = new CoworkHomeContactComponent();

        //Init Formtwo
        contactComponent.on('formTwo', () => {
            this.refs.detailFormBtn.click();
            this.initializeDetailForm();
        });
    }

    /**
     * Initializes the extra detail modal component
     */
    initializeDetailForm() {
        const contactComponent = new CoworkHomeDetailComponent();
    }

    /**
     * Initializes the search box
     */
    initializeSearchBox() {
         const searchComponent = new CoworkHomeSearchComponent();
    }

    /*
     * Initialize top cities
     */
    initializeTopCities(){
        const topCities = new CoworkTopCitiesComponent();
    }

    /*
     * Initialize categories
     */
    initializeCategories(){
        const categoriesComponent = new CoworkCategoriesComponent();
    }

    /**
     * Initializes the featured spaces
     */
    initializeFeaturedSpaces(){
        const featuredSpaces = new CoworkFeaturedSpacesComponent();
        
    }

    /**
     * Initializes the popular spaces
     */
    initializePopularSpaces(){
        const popularSpaces = new CoworkPopularSpacesComponent();
    }

    /**
     * Initializes featured partners
     */
    initializeFeaturedPartners(){
        const featuredPartners = new CoworkFeaturedPartnersComponent();
    }

    /**
     * Initializes popular partners
     */
    initializePopularPartners(){
        const popularPartners = new CoworkPopularPartnersComponent();
    }

    /**
     * Initializes offers
     */
    initializeOffers(){
        const offers = new CoworkOffersComponent();
    } 

}
